import { Component, OnInit } from "@angular/core";
import { Annotation } from "../../interfaces/annotation";
import { Project } from "../../interfaces/project";
import { ProjectService } from "../../services/project/project.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AnnotationService } from "../../services/annotation/annotation.service";
import { AnnotationtypeService } from "../../services/annotationtype/annotationtype.service";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-annotations",
  templateUrl: "./annotations.component.html",
  styleUrls: ["./annotations.component.scss"],
})
export class AnnotationsComponent implements OnInit {
  env: any = environment;
  loading: boolean;
  annotations: Array<Annotation>;
  annotationtypes: Object;
  project: Project;

  constructor(
    private projectService: ProjectService,
    private route: ActivatedRoute,
    private annotationService: AnnotationService,
    private annotationtypeService: AnnotationtypeService,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params: { id: string }) => {
      this.loading = true;
      this.projectService
        .getProjectByShortId(params.id)
        .then((project: Project) => {
          this.project = project;
          this.getAnnotations();
          this.getAnnotationtypes();
        })
        .catch((error) => {
          this.loading = false;
        });
    });
  }

  getAnnotations() {
    this.annotationService
      .getAnnotationsByProjectId(this.project._id)
      .then((annotations: Array<Annotation>) => {
        this.annotations = this.getSortedArray(annotations);
        this.loading = false;
      });
  }

  getAnnotationtypes() {
    this.annotationtypeService
      .getAnnotationtypesByVersion(this.project.version)
      .then((annotationtypes) => {
        this.annotationtypes = annotationtypes;
      });
  }

  createAnnotation() {
    this.loading = true;
    this.annotationService
      .createAnnotation({ projectId: this.project._id })
      .then((annotation: Annotation) => {
        this.loading = false;
        this.router.navigate(["/annotation-detail/" + annotation.shortId]);
      });
  }

  /**
   * returns the maximum height of all row-annotation-dashboard-type class elements
   * @returns {number}
   */
  getMaxHeight() {
    let maxHeight = 0;
    jQuery(".row-annotation-dashboard-type").each(() => {
      let temp = jQuery(this).height();
      if (temp > maxHeight) {
        maxHeight = temp;
      }
    });
    return maxHeight;
  }

  /**
   * returns projects by created date
   * @type {Array<Project>}
   */
  private getSortedArray(annotations) {
    return annotations.sort(
      (a: any, b: any) =>
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
    );
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/annotations/annotations.component.ts